
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletter/archive/[issue]",
      function () {
        return require("private-next-pages/newsletter/archive/[issue].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletter/archive/[issue]"])
      });
    }
  